(function () {
  function inViewport(el) {
    var r = el.getBoundingClientRect();
    return r.bottom > 0 && r.top < window.innerHeight && r.right > 0 && r.left < window.innerWidth;
  }

  /* ---------- Marquee ---------- */
  function setupMarquee(track) {
    var viewport = track.parentElement;
    if (!viewport || !viewport.clientWidth) return;

    track.querySelectorAll('[data-eo-clone]').forEach(function (c) { c.remove(); });
    viewport.classList.remove('is-marquee');
    track.style.removeProperty('--eo-shift');
    track.style.removeProperty('--eo-duration');
    track.setAttribute('data-eo-ready', '1');

    var originals = Array.prototype.slice.call(track.children);

    // Marquee tabhi jab offers container se zyada chaude hon
    if (originals.length < 1 || track.scrollWidth <= track.clientWidth + 2) return;

    originals.forEach(function (el) {
      var c = el.cloneNode(true);
      c.setAttribute('aria-hidden', 'true');
      c.setAttribute('data-eo-clone', '');
      c.querySelectorAll('img').forEach(function (img) { img.loading = 'eager'; });
      track.appendChild(c);
    });

    var items = track.children;
    var w = items[originals.length].getBoundingClientRect().left - items[0].getBoundingClientRect().left;
    var speed = parseFloat(track.getAttribute('data-eo-marquee')) || 40;   // px per second

    track.style.setProperty('--eo-shift', (-w) + 'px');
    track.style.setProperty('--eo-duration', (w / speed) + 's');
    viewport.classList.add('is-marquee');
  }

  /* ---------- Slider: ek ek offer ---------- */
  function setupSlide(track) {
    var viewport = track.parentElement;
    if (!viewport || !viewport.clientWidth) return;

    track.style.setProperty('--eo-vw', viewport.clientWidth + 'px');
    track.setAttribute('data-eo-ready', '1');

    var items = track.children;
    if (!items.length || track.querySelector('.is-active')) return;

    // Pehla offer bina animation ke dikhao
    var first = items[0];
    first.classList.add('is-active', 'is-still');
    requestAnimationFrame(function () {
      requestAnimationFrame(function () { first.classList.remove('is-still'); });
    });
  }

  function advance(track) {
    var items = track.children;
    if (items.length < 2) return;

    var cur = track.querySelector('.is-active');
    var idx = cur ? Array.prototype.indexOf.call(items, cur) : -1;
    var next = items[(idx + 1) % items.length];

    if (cur) {
      cur.classList.remove('is-active');
      cur.classList.add('is-leaving');
      setTimeout(function () { cur.classList.remove('is-leaving'); }, 700);
    }
    next.classList.remove('is-leaving');
    next.classList.add('is-active');
  }

  function tickSlide() {
    var any = document.querySelector('[data-eo-slide]');
    var seconds = any ? (parseFloat(any.getAttribute('data-eo-time')) || 3) : 3;

    if (!document.hidden) {
      document.querySelectorAll('[data-eo-slide][data-eo-ready]').forEach(function (t) {
        if (t.matches(':hover') || !inViewport(t)) return;   // hover par pause
        advance(t);
      });
    }

    setTimeout(tickSlide, Math.max(1.5, seconds) * 1000);
  }

  /* ---------- Setup / resize ---------- */
  function scan() {
    document.querySelectorAll('[data-eo-marquee]:not([data-eo-ready])').forEach(setupMarquee);
    document.querySelectorAll('[data-eo-slide]:not([data-eo-ready])').forEach(setupSlide);
  }

  function resetAll() {
    document.querySelectorAll('[data-eo-ready]').forEach(function (t) { t.removeAttribute('data-eo-ready'); });
    scan();
  }

  // Naye cards (filters, pagination, drawer) ke liye halka polling
  setInterval(scan, 1000);
  scan();
  window.addEventListener('load', scan);
  if (document.fonts && document.fonts.ready) document.fonts.ready.then(resetAll);

  var resizeT, lastW = window.innerWidth;
  window.addEventListener('resize', function () {
    clearTimeout(resizeT);
    resizeT = setTimeout(function () {
      if (window.innerWidth === lastW) return;
      lastW = window.innerWidth;
      resetAll();
    }, 200);
  });

  setTimeout(tickSlide, 3000);

  /* ---------- Swipe mode: mouse drag ---------- */
  var dragTrack = null, startX = 0, startLeft = 0;

  document.addEventListener('pointerdown', function (e) {
    if (e.pointerType !== 'mouse' || e.button !== 0) return;
    var t = e.target.closest && e.target.closest('[data-eo-swipe]');
    if (!t || t.scrollWidth <= t.clientWidth) return;
    dragTrack = t;
    startX = e.clientX;
    startLeft = t.scrollLeft;
    t.classList.add('is-dragging');
  });

  document.addEventListener('pointermove', function (e) {
    if (!dragTrack) return;
    dragTrack.scrollLeft = startLeft - (e.clientX - startX);
  });

  function stopDrag() {
    if (!dragTrack) return;
    dragTrack.classList.remove('is-dragging');
    dragTrack = null;
  }
  document.addEventListener('pointerup', stopDrag);
  document.addEventListener('pointercancel', stopDrag);
})();